import React from 'react'
import { useSelector } from 'react-redux'
import { prop } from 'ramda'
import { RootState } from 'app/store'
import { isAdminRole } from 'k8s/util/helpers'
import { SessionState, sessionStoreKey } from 'core/session/sessionReducers'
import { routes } from 'core/utils/routes'
import DocumentMeta from 'core/components/DocumentMeta'
import Tabs from 'core/elements/tabs'
import Tab from 'core/elements/tabs/Tab'
import MyProfilePage from './my-profile-page'
import MFASettingsPage from './MFASettingsPage'
import { HeaderTitlePortal } from 'core/elements/header/portals'
import PassiveHeaderLink from 'core/components/passive-header-link'
import { dashboardUrl } from 'app/constants'

const UserSettingsIndexPage = () => {
  const session = useSelector<RootState, SessionState>(prop(sessionStoreKey))
  const { isSsoToken } = session

  if (!isAdminRole(session)) {
    return <MyProfilePage />
  }
  return (
    <>
      <DocumentMeta title="My Account" />
      <HeaderTitlePortal>
        <PassiveHeaderLink icon="chevron-left" text="Back to Dashboard" url={dashboardUrl} />
      </HeaderTitlePortal>
      <Tabs route={routes.userSettings.root}>
        <Tab value="profile" label="Account Details">
          <MyProfilePage />
        </Tab>
        {!isSsoToken && (
          <Tab value="mfa" label="Multifactor Authentication">
            <MFASettingsPage />
          </Tab>
        )}
      </Tabs>
    </>
  )
}

export default UserSettingsIndexPage
